import { Building2, HeartPulse, GraduationCap, Store, ArrowUpRight } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const INDUSTRIES = [
  {
    title: "Real Estate",
    desc: "Developers, builders & channel partners across Pune",
    icon: Building2,
    img: IMAGES.industryRealEstate,
    testid: "industry-real-estate",
  },
  {
    title: "Healthcare",
    desc: "Hospitals, clinics & specialist practices",
    icon: HeartPulse,
    img: IMAGES.industryHealthcare,
    testid: "industry-healthcare",
  },
  {
    title: "Education",
    desc: "Schools, colleges & coaching institutes",
    icon: GraduationCap,
    img: IMAGES.industryEducation,
    testid: "industry-education",
  },
  {
    title: "Local Businesses",
    desc: "Retail, services & emerging brands in Pune",
    icon: Store,
    img: IMAGES.industryLocal,
    testid: "industry-local",
  },
];

export const Industries = () => {
  return (
    <section id="industries" data-testid="industries-section" className="section-pad bg-surface">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange mb-3">
            Industries We Serve
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight tracking-tight">
            Specialists in real estate. <span className="text-blue">Trusted across industries.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind) => {
            const Icon = ind.icon;
            return (
              <a
                key={ind.testid}
                data-testid={ind.testid}
                href="#contact"
                className="industry-card relative h-[360px] rounded-3xl overflow-hidden group block"
              >
                <img
                  src={ind.img}
                  alt={ind.title}
                  loading="lazy"
                  className="bg-img absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 dark-overlay" />
                <div className="relative h-full p-6 flex flex-col justify-between text-white">
                  <div className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur-md flex items-center justify-center border border-white/20">
                    <Icon size={20} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-extrabold leading-tight mb-1">{ind.title}</h3>
                    <p className="text-sm text-white/80 mb-4">{ind.desc}</p>
                    <div className="inline-flex items-center gap-1.5 text-orange font-semibold text-sm">
                      Get a strategy <ArrowUpRight size={16} />
                    </div>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
